import { ProductCategory } from "@/products/entities/product-category"

export default class ProductInventoryFilter {
  public category: ProductCategory = ProductCategory.Anleimer
  public manufacturerId: string = ''
  public supplierId: string = ''
  public bulkGoodsOnly: boolean = false
}
